export var formFieldId = function (field) {
  return "field-".concat(field.id || field.name);
};